export const getTimezoneTime = (isoString: string, tz: string) => {
  if (tz === "CDT") {
    tz = "CST";
  }
  if (tz === "EDT") {
    tz = "EST";
  }
  if (tz === "MDT") {
    tz = "MST";
  }
  const date = new Date(isoString);
  return date.toLocaleTimeString("en-US", {
    timeZone: tz,
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const downloadFile = async (url: string, filename: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    
    // The temporary link element can interfere with CSS cursor states
    // Cleanup needed to ensure the cursor icon always updates properly 
    // on hover after downloading a file
    // Clean up after a short delay to ensure download starts first
    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
      URL.revokeObjectURL(link.href);
    }, 1000);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
}; 